import { render, staticRenderFns } from "./StatsUpgradeTab.vue?vue&type=template&id=c7a6b2ea&scoped=true&"
import script from "./StatsUpgradeTab.vue?vue&type=script&lang=js&"
export * from "./StatsUpgradeTab.vue?vue&type=script&lang=js&"
import style0 from "./StatsUpgradeTab.vue?vue&type=style&index=0&id=c7a6b2ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a6b2ea",
  null
  
)

export default component.exports